import React from "react";
import { t } from "i18next";
import { Box, Button, Paper, Typography } from "@mui/material";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useHistory } from "react-router";
import { LeaderboardEntry } from "../../shared/interfaces/GameLogicTypes";

interface Props {
  creators: LeaderboardEntry[] | null;
}

const medalColors = ["#ffc107", "#aaa", "#cd7f32"];

export default function LeaderboardTeaser({ creators }: Props) {
  const history = useHistory();
  const top3 = (creators || []).slice(0, 3);

  return (
    <Paper
      elevation={2}
      sx={{
        p: 3,
        borderRadius: 3,
        flex: 1,
        minWidth: { xs: "100%", md: 220 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1.5,
        cursor: "pointer",
        transition: "transform 0.2s, box-shadow 0.2s",
        "&:hover": { transform: "translateY(-4px)", boxShadow: 6 },
        background: "linear-gradient(135deg, rgba(255,193,7,0.08) 0%, rgba(255,255,255,0.9) 100%)",
      }}
      onClick={() => history.push("/community?tab=leaderboard")}
    >
      <EmojiEventsIcon sx={{ fontSize: 48, color: "#ffc107" }} />
      <Typography variant="subtitle2" fontWeight="bold">
        {t("leaderboard_teaser_title")}
      </Typography>
      {top3.length > 0 ? (
        <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: 0.5 }}>
          {top3.map((c, i) => (
            <Box
              key={c.name}
              sx={{ display: "flex", alignItems: "center", gap: 1 }}
            >
              <Typography
                variant="body2"
                fontWeight="bold"
                sx={{ color: medalColors[i], minWidth: 20 }}
              >
                #{i + 1}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  flex: 1,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {c.name}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {c.playCount} {t("leaderboard_teaser_plays")}
              </Typography>
            </Box>
          ))}
        </Box>
      ) : (
        <Typography variant="body2" color="text.secondary">
          {t("leaderboard_teaser_empty")}
        </Typography>
      )}
      <Button
        size="small"
        endIcon={<ArrowForwardIcon />}
        sx={{ mt: "auto", color: "#ffc107" }}
      >
        {t("leaderboard_teaser_full")}
      </Button>
    </Paper>
  );
}
